/**
 * Uniba ServiziOnline reducer
 * @module src/reducers/unibaServiziOnlineReducer
 */

import { GET_UNIBA_SHOWSERVIZIONLINE } from 'design-comuni-plone-theme/actions';

const initialState = {
  error: null,
  hasError: false,
  result: false,
  loadingResults: false,
};

export const unibaShowServiziOnlineReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_UNIBA_SHOWSERVIZIONLINE}_PENDING`:
      return {
        ...state,
        result: false,
        loadingResults: true,
      };
    case `${GET_UNIBA_SHOWSERVIZIONLINE}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loadingResults: false,
      };
    case `${GET_UNIBA_SHOWSERVIZIONLINE}_FAIL`:
      return {
        ...state,
        error: action.error,
        result: false,
        hasError: true,
        loadingResults: false,
      };
    default:
      return state;
  }
};
